module.exports = __webpack_public_path__ + "img/eye.2a9e5375.svg";